import reducer from './order-party.reducer'

export default reducer
